/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：2003
 */

module.exports = function () {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
}
